import { useSearchParams } from 'react-router-dom';
import { Fragment } from 'react';
import DesignSideBar from './Design/DesignSideBar';

const Components = {
  design: DesignSideBar,
};
const FormSetupRightSideBar = () => {
  const [searchParams] = useSearchParams();
  const Component = Components[searchParams.get('a')] || Fragment;

  return (
    <Component />
  );
};

export default FormSetupRightSideBar;
